import { Box, ModalHeader, SecondaryButton } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import {
  TKeyBuilder,
  useWriskTranslation,
} from '../../../../infrastructure/internationalisation'

export interface SuccessModalProps {
  tKey: TKeyBuilder
  onClose: () => void
}

export const SuccessModal: FunctionComponent<SuccessModalProps> = ({ tKey, onClose }) => {
  const { t } = useWriskTranslation()

  return (
    <Box>
      <ModalHeader
        header={t(tKey('success-modal', 'header'))}
        subheader={t(tKey('success-modal', 'subheader'), { defaultValue: null })}
      />
      <SecondaryButton onClick={onClose}>{t(tKey('actions', 'close'))}</SecondaryButton>
    </Box>
  )
}
